import { PREFIX_ID } from '@/constants';
import IState from "@/interfaces/IState";
import ITrafficSource from "@/interfaces/ITrafficSource";

export default (state: IState, payload: ITrafficSource[]) => {
  state.trafficSources = payload.reduce(
    (acc: { [key: string]: ITrafficSource }, trafficSource) => {
      acc[`${PREFIX_ID}${trafficSource.id}`] = trafficSource;
      return acc;
    },
    {}
  );
};
